<template>
  <div class="main">
    <div class="login-container">
      <img alt="gefundn. Logo" src="../assets/images/logo-text-only.png">
      <p class="description">Finde echte Menschen <br>für jede Aktivität.</p>
      <h1 v-if="forgotPassword">Passwort zurücksetzen</h1>
      <p v-if="msg" style="max-width: 400px;">{{msg}}</p>
      <div class="login-form" v-if="loginMode && !forgotPassword">
        <form v-on:submit.prevent="submit">
          <table class="login-fields">
            <tbody>
              <tr>
                <td><label for="email">E-Mail</label></td>
                <td><input type="text" id="email" v-model="credentials.email"></td>
              </tr>
              <tr>
                <td><label for="password">Passwort</label></td>
                <td><input type="password" id="password" v-model="credentials.password"></td>
              </tr>
            </tbody>
          </table>
          <div class="buttons">
            <button type="submit" class="login">Anmelden</button>
            <button class="to-register" @click="loginMode = false;">Registrieren</button>
            <button class="to-forgot" @click="forgotPassword = true;">Passwort vergessen?</button>
          </div>
        </form>
      </div>
      <div class="register-form" v-if="!loginMode && !forgotPassword">
        <form v-on:submit.prevent="submit">
          <table class="login-fields">
            <tbody>
              <tr>
                <td><label for="email">E-Mail</label></td>
                <td><input type="text" id="email" v-model="credentials.email"></td>
              </tr>
              <tr>
                <td><label for="password">Passwort</label></td>
                <td><input type="password" id="password" v-model="credentials.password"></td>
              </tr>
              <tr>
                <td><label for="password">Wiederholen</label></td>
                <td><input type="password" id="password" v-model="credentials.password_repeat"></td>
              </tr>
              <tr>
                <td></td>
                <td><p class="privacy-info">Mit der Registrierung bestätigen Sie, unserer <router-link to="/privacy">Datenschutzerklärung</router-link> zuzustimmen.</p></td>
              </tr>
            </tbody>
          </table>
          <div class="buttons">
            <button type="submit" class="login">Registrieren</button>
            <button class="to-register" @click="loginMode = true;">Zurück zum Login</button>
            <button class="to-forgot" @click="forgotPassword = true;">Passwort vergessen?</button>
          </div>
        </form>
      </div>
      <div class="forgot-form" v-if="forgotPassword">
        <form v-on:submit.prevent="submit">
          <table class="login-fields" v-if="!forgotPasswordDone">
            <tbody>
              <tr>
                <td><label for="email">E-Mail</label></td>
                <td><input type="text" id="email" v-model="credentials.email"></td>
              </tr>
            </tbody>
          </table>
          <div class="buttons">
            <button type="submit" class="login" v-if="!forgotPasswordDone">Passwort anfordern</button>
            <button class="to-register" @click="forgotPassword = false;" v-if="!forgotPasswordDone">Abbruch</button>
            <button type="submit" class="login" v-if="forgotPasswordDone" @click="reload">Fertig</button>
          </div>
        </form>
      </div>
    </div>
    
    <!-- PWA Install Banner -->
    <Teleport to="body">
      <div v-if="showPwaBanner" class="pwa-banner-overlay">
        <div class="pwa-banner-card">
          <div class="pwa-logo-wrapper">
            <img class="pwa-app-icon" src="../assets/images/logo-text-only.png" alt="gefundn. Logo">
          </div>
          <h2>App installieren</h2>
          <p class="pwa-intro">Installiere gefundn. auf deinem Startbildschirm für das beste Erlebnis, Push-Benachrichtigungen und schnellen Zugriff.</p>
          
          <!-- iOS Instructions -->
          <div v-if="isIOS" class="pwa-instructions">
            <div class="step">
              <span class="step-num">1</span>
              <p>Tippe unten im Browser auf das <strong>Teilen-Symbol</strong> <span class="share-icon">⎋</span>.</p>
            </div>
            <div class="step">
              <span class="step-num">2</span>
              <p>Wähle im Menü <strong>„Zum Home-Bildschirm“</strong>.</p>
            </div>
            <div class="step">
              <span class="step-num">3</span>
              <p>Tippe oben rechts auf <strong>„Hinzufügen“</strong>.</p>
            </div>
          </div>
          
          <!-- Android / Chrome Instructions -->
          <div v-else class="pwa-instructions">
            <div class="step" v-if="deferredPrompt">
              <span class="step-num">1</span>
              <p>Klicke auf den Button unten, um die App direkt auf deinem Gerät zu installieren.</p>
            </div>
            <div v-else>
              <div class="step">
                <span class="step-num">1</span>
                <p>Tippe auf das Menü-Symbol (drei Punkte) oben rechts im Browser.</p>
              </div>
              <div class="step">
                <span class="step-num">2</span>
                <p>Wähle <strong>„App installieren“</strong> oder <strong>„Zum Startbildschirm hinzufügen“</strong>.</p>
              </div>
            </div>
          </div>

          <div class="pwa-actions">
            <button v-if="!isIOS && deferredPrompt" class="install-btn" @click="installPwa">App installieren</button>
            <button class="dismiss-btn" @click="showPwaBanner = false">Trotzdem im Browser nutzen</button>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService.js';

export default {
  name: 'LoginView',
  data() {
    return {
      loginMode: true,
      forgotPassword: false,
      forgotPasswordDone: false,
      credentials: {
        email: null,
        password_repeat: null,
        password: null,
      },
      msg: null,
      showPwaBanner: false,
      isIOS: false,
      deferredPrompt: null,
    };
  },
  components: {
  },
  async created() {
    if (!this.$store.getters.isLoggedIn) {
      console.error("not logged in!")
    } else {
      this.$router.push('/');
    }

    this.username = this.$store.getters.getUser.username;

    // Detect mobile device
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    // Detect if running in standalone mode
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    
    this.isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    this.showPwaBanner = isMobile && !isStandalone;

    // Load globally captured deferred prompt if available
    this.deferredPrompt = window.deferredPrompt;

    // Listen for custom event in case it fires after mount
    window.addEventListener('pwa-install-prompt-available', (e) => {
      this.deferredPrompt = e.detail;
    });
  },
  methods: {
    async installPwa() {
      if (!this.deferredPrompt) return;
      this.deferredPrompt.prompt();
      const { outcome } = await this.deferredPrompt.userChoice;
      console.log(`User choice: ${outcome}`);
      this.deferredPrompt = null;
      this.showPwaBanner = false;
    },
    async submit(){
      this.msg = null;

      if(!this.validateCredentials()){
        return false
      }

      if(this.forgotPassword){
        try{
          let result = await AuthService.forgotPassword(this.credentials);
          if(result.success){
            this.msg = result.msg
            this.forgotPasswordDone = true;
          }
        } catch(e){
          console.error(e)
          this.msg = e.response.data.msg
        }
      } else if(this.loginMode) {
        try{
          let result = await AuthService.login(this.credentials);
          if(result.success){
            this.msg = "Login erfolgreich!"
            const token = result.token;
            const user = result.user;

            this.$store.dispatch('login', { token, user });
            this.$router.push('/');
          }
        } catch(e){
          console.error(e)
          this.msg = e.response.data.msg
        }
      } else { //if we are not logging in, we are registering
        if(this.credentials.password !== this.credentials.password_repeat){
          this.msg = "Die Passwörter stimmen nicht überein!"
        } else {
          try{
            let result = await AuthService.signUp(this.credentials);
            console.log(result)
            if(result.success){
              this.msg = "Registrierung erfolgreich!"
              this.loginMode = true;
            }
          } catch(e){
            console.error(e)
            this.msg = e.response.data.msg
          }
        }
      }
    },
    validateCredentials(){
      if(!this.validateEmail(this.credentials.email)){
        this.msg = "Bitte gib eine gültige E-Mail Adresse an!"
        return false
      }

      if(!this.forgotPassword && !this.credentials.password){
        this.msg = "Bitte gib ein Passwort ein!"
        return false
      }

      if(!this.forgotPassword && !this.loginMode && (this.credentials.password !== this.credentials.password_repeat)){
        this.msg = "Passwörter stimmen nicht überein!"
        return false
      }

      return true
    },
    validateEmail(email){
      return String(email)
          .toLowerCase()
          .match(
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
    },
    reload() {
      this.$router.go();
    }
  }
}
</script>
<style scoped>
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px;
  background: transparent;
}

.login-container {
  width: 100%;
  max-width: 380px;
  background: var(--card-bg);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: var(--radius-xl);
  padding: 40px 32px;
  box-shadow: var(--shadow-strong);
  text-align: center;
}

img {
  width: 220px;
}

p.description{
  font-size: 0.9rem;
  font-weight: 400;
  color: var(--text-secondary);
  margin: 0;
  margin-bottom: 24px;
}

h1 {
  font-size: 1.2rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  margin-bottom: 12px;
  color: var(--text-main);
}

.login-form, .register-form, .forgot-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 8px;
}

tr > td:nth-child(1) {
  text-align: left;
}

tr > td:nth-child(2) {
  text-align: right;
}

label {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin-left: 4px;
  text-align: left;
}

input {
  width: 90%;
  background: #F5F5F7;
  border: 1px solid transparent;
  padding: 14px 18px;
  border-radius: var(--radius-m);
  font-family: var(--font);
  font-size: 1rem;
  outline: none;
  box-sizing: border-box;
  transition: all 0.2s ease;
}

input:focus {
  background: white;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 4px rgba(0, 122, 255, 0.1);
}

.buttons {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

button.login {
  background: var(--primary-color);
  color: white;
  padding: 16px;
  border-radius: var(--radius-m);
  font-weight: 700;
  font-size: 1.1rem;
  border: none;
}

button.to-register, button.to-forgot {
  background: none;
  border: none;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--primary-color);
}

.privacy-info {
  font-size: 0.75rem;
  color: var(--text-secondary);
  margin: 12px 0;
  line-height: 1.4;
}

.privacy-info a {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 600;
}

/* PWA Install Banner Styles */
.pwa-banner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
}

.pwa-banner-card {
  background: white;
  border-radius: var(--radius-xl);
  padding: 36px 28px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  text-align: center;
  animation: pwaSlideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  box-sizing: border-box;
}

@keyframes pwaSlideUp {
  from { transform: translateY(40px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.pwa-logo-wrapper {
  margin-bottom: 24px;
}

.pwa-app-icon {
  width: 160px;
  height: auto;
  object-fit: contain;
}

.pwa-banner-card h2 {
  font-size: 1.6rem;
  font-weight: 800;
  color: #1D1D1F;
  margin: 0 0 12px 0;
  letter-spacing: -0.02em;
}

.pwa-intro {
  font-size: 0.95rem;
  color: var(--text-secondary);
  line-height: 1.5;
  margin: 0 0 28px 0;
}

.pwa-instructions {
  background: #F5F5F7;
  border-radius: var(--radius-m);
  padding: 20px;
  margin-bottom: 28px;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid var(--border-color);
}

.step {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.step-num {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: var(--primary-color);
  color: white;
  font-size: 0.85rem;
  font-weight: 800;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 2px;
}

.step p {
  font-size: 0.9rem;
  color: #1D1D1F;
  margin: 0;
  line-height: 1.45;
}

.share-icon {
  display: inline-block;
  font-size: 1.1rem;
  vertical-align: middle;
  margin: 0 2px;
  color: var(--primary-color);
}

.pwa-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.install-btn {
  background: var(--primary-color);
  color: white;
  padding: 16px;
  border-radius: var(--radius-m);
  font-weight: 700;
  font-size: 1.05rem;
  border: none;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.1s ease;
}

.install-btn:hover {
  background: #0066d6;
}

.install-btn:active {
  transform: scale(0.98);
}

.dismiss-btn {
  background: none;
  border: none;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--primary-color);
  cursor: pointer;
  padding: 8px;
  transition: opacity 0.2s ease;
}

.dismiss-btn:hover {
  opacity: 0.8;
}
</style>
